import { gql } from '@apollo/client'
import { Domiciliation } from 'globals/models/Domiciliation'

export const LIST_DOMICILIATIONS = gql`
  query domiciliations(
    $prefilter: DomiciliationsPrefilters!
    $searchTerm: String
    $page: Int!
  ) {
    domiciliations(
      prefilter: $prefilter
      searchTerm: $searchTerm
      page: $page
    ) {
      id
      firstname
      lastname
      email
      status
      canceledAt
      cancelationDocumentPdf
      clientSince
      address {
        id
        ownAddress
      }
      forwardingAddress {
        id
        name
        streetAddress
        postalCode
        city
        country
      }
      mailForwardingFrequency
      pendingUserMailsCount
      phoneNumber
      postalProcurationReady
      society {
        id
        name
        legalStatus
        brandName
      }
      userMailOption
      leaderEmail
      leaderPhoneNumber
      siretOrRna
      subscriptionState
      npai
      firstPaymentCountryOrigin
    }
  }
`

export type ListDomiciliationsPrefilter = 'all' | 'activated' | 'pending_partner_check' | 'canceled' | 'npai'

export interface ListDomiciliationsVariables {
  prefilter: ListDomiciliationsPrefilter,
  searchTerm?: string,
  page: number
}

export interface ListDomiciliationsResult {
  domiciliations: Domiciliation[]
}


